import React from 'react';
import {BrowserRouter, Switch, Route, Redirect} from 'react-router-dom';
import Cookies from 'js-cookie';
// ----------------------------
import Login from '../../screen/login';
import autoboox from '../../screen/autoboox';
import AutobooxMeta from '../../screen/autoboox_meta';
import Vistoria from '../../screen/Vistoria';
import Cotacao from '../../screen/Cotacao';
import Politica from '../../screen/Politica/politica';
import Termos from '../../screen/Politica/termos';

import Home from '../../screen/home';
import { VistoriaLista } from '../../screen/Vistoria_Lista';
import { COTACAO_SIMPLES } from '../../screen/Cotacao_Simples';
import AddCotacao from '../../screen/add_cotacao';
import Cadastro from '../../screen/Cadastro';
import Add from '../../screen/Add';
import Cobranca from '../../screen/Cobranca';
import EstoquePecas from '../../screen/EstoquePecas';
import AddResult from '../../screen/contaUser';
import QrCode from '../../screen/qrcode';
import NaoEncontrada from '../../screen/naoEncontrada';
import Dashboard from '../../screen/dashboard';

// Rota que só abre com usuário logado (token no cookie); caso contrário vai para o login
function PrivateRoute({ component: Component, ...rest }) {
    return (
        <Route
            {...rest}
            render={props =>
                Cookies.get('token')
                    ? <Component {...props} />
                    : <Redirect to="/login" />
            }
        />
    );
}

export default function Routes(){
    const hostname = window.location.hostname;
    const isAutoboxDomain = hostname === 'autobox.maisapoio.com.br';

    return(
        <BrowserRouter>
            <Switch>
                {isAutoboxDomain ? (
                    <>
                    <Route path="/autoboox/meta-setup" exact component={AutobooxMeta} />
                    <Route path="/" exact component={autoboox} />
                    </>
                ) 
                : 
                (
                    <>
                    <Route path="/autoboox" exact component={autoboox}/> 
                    <Route path="/autoboox/meta-setup" exact component={AutobooxMeta}/>
                    <Route path="/vistoria" exact component={Vistoria}/> 
                    <Route path="/cotacao" exact component={Cotacao}/> 
                    <Route path="/login" exact component={Login}/>
                    <Route path="/politicaprivacidade" exact component={Politica}/> 
                    <Route path="/termocondicoes" exact component={Termos}/>  

                    <PrivateRoute path="/" exact component={Add}/>
                    <PrivateRoute path="/home" exact component={Home}/>
                    <PrivateRoute path="/Addcotacao" exact component={AddCotacao}/>
                    <PrivateRoute path="/cotasimples" exact component={COTACAO_SIMPLES}/>
                    <PrivateRoute path="/cadastro" exact component={Cadastro}/>
                    <PrivateRoute path="/dashboard" exact component={Dashboard}/>
                    <PrivateRoute path="/cobranca" exact component={Cobranca}/>
                    <PrivateRoute path="/estoquePecas" exact component={EstoquePecas}/>
                    <PrivateRoute path="/evento/:id" exact component={Add}/>
                    <PrivateRoute path="/vistoriaLista" exact component={VistoriaLista}/>
                    <PrivateRoute path="/addresult/:_id" exact component={AddResult}/>
                    <PrivateRoute path="/qrcode" exact component={QrCode}/>
                    <PrivateRoute path="/NaoEncontrada" exact component={NaoEncontrada}/> 
                    </>       
                )}          
            </Switch>
        </BrowserRouter>
    )
}
